/**
 * The id of the trigger a `/triggers/<segment>` URL addresses, or `null` when
 * the segment does not end in a trigger id.
 *
 * @param segment expected to look like the pattern `blah-tr_123` or `tr_123`
 */
export function triggerIdFromSegment(segment: string): string | null {
  // Everything after the last `-`, or the whole segment. Ids never contain a
  // `-`, so a name that does (`foo-tr_x`) is never mistaken for the id.
  // The rest of an id's shape is not checked: a malformed one reads as a trigger
  // that does not exist.
  const tail = segment.slice(segment.lastIndexOf("-") + 1);
  return tail.startsWith("tr_") && tail.length > "tr_".length ? tail : null;
}
